<div class="settingMessage">
  <mat-spinner [diameter]="48" />
  <p>Loading client data</p>
</div>
